<template>
  <div>
    <table class="table table-striped w-100" style="table-layout: fixed;">
      <colgroup v-if="getVisibleColumnCount() === 7">
        <col style="width:13%" />
        <col style="width:37%" />
        <col style="width:13%" />
        <col style="width:37%" />
        <col style="width:13%" />
        <col style="width:37%" />
        <col style="width:10%" />
      </colgroup>
      <colgroup v-else>
        <col style="width:13%" />
        <col style="width:37%" />
        <col style="width:13%" />
        <col style="width:37%" />
        <col style="width:10%" />
      </colgroup>
      <thead>
        <tr style="background-color: lightslategray; color: white; text-align: center;">
          <th colspan="7" style="font-weight: normal;">CPT Coding</th>
        </tr>
        <tr style="text-align: left;">
          <th v-if="showPreCptCodeType()" style="border-bottom: 1px solid #ebeef5 !important">Code</th>
          <th v-if="showPreCptCodeType()" style="border-bottom: 1px solid #ebeef5 !important; border-right: 1px solid #ebeef5 !important">Description</th>
          <th v-if="showOriginalCptCodeType()" style="border-bottom: 1px solid #ebeef5 !important">Code</th>
          <th v-if="showOriginalCptCodeType()" style="border-bottom: 1px solid #ebeef5 !important; border-right: 1px solid #ebeef5 !important">Description</th>
          <th style="border-bottom: 1px solid #ebeef5 !important">Code</th>
          <th style="border-bottom: 1px solid #ebeef5 !important">Description</th>
          <th style="border-bottom: 1px solid #ebeef5 !important">Reason</th>
        </tr>
      </thead>
      <tbody>
        <tr v-if="getVisibleColumnCount() !== 7 && worksheet.cpts.length > 0">
          <td colspan="2" class="codeTypeHeader">
            <div>{{ showPreCptCodeType() ? worksheet.cpts[0].preCptCodeDesc : worksheet.cpts[0].codeDesc }}</div>
          </td>
          <td colspan="3" class="codeTypeHeader">
            <div>Recommended CPT Coding</div>
          </td>
        </tr>
        <tr v-if="getVisibleColumnCount() === 7 && worksheet.cpts.length > 0">
          <td colspan="2" class="codeTypeHeader">
            <div>{{ worksheet.cpts[0].preCptCodeDesc }}</div>
          </td>
          <td colspan="2" class="codeTypeHeader">
            <div>{{ worksheet.cpts[0].codeDesc }}</div>
          </td>
          <td colspan="3" class="codeTypeHeader">
            <div>Recommended CPT Coding</div>
          </td>
        </tr>
        <tr :class="{ bold: isCptRowChange(cpt) }" v-for="cpt in worksheet.cpts" :key="cpt.cptId">
          <td v-if="showPreCptCodeType()" :class="{ 'red-font': isPreCptRedFont(cpt, worksheet.cpts) }">
            {{ cpt.preCpt }}
          </td>
          <td v-if="showPreCptCodeType()" :class="{ 'red-font': isPreCptRedFont(cpt, worksheet.cpts) }" style="border-right: 1px solid #ebeef5">
            {{ cpt.preCptDesc }}
          </td>

          <td v-if="showOriginalCptCodeType()" :class="{ 'red-font': isOriginalRedFont(cpt, worksheet.cpts) }" :style="cpt.preCptDeleted ? 'text-decoration: line-through' : ''">{{ cpt.preCptDeleted ? cpt.preCpt : cpt.originalCPT }}{{ cpt.originalModifierCalc }}</td>
          <td v-if="showOriginalCptCodeType()" :class="{ 'red-font': isOriginalRedFont(cpt, worksheet.cpts) }" style="border-right: 1px solid #ebeef5">
            {{ cpt.preCptDeleted ? 'Delete Code' : cpt.origDesc }}
          </td>
          <td :class="{ 'red-font': isRecommendedRedFont(cpt, worksheet.cpts) }" :style="cpt.originalDeleted ? 'text-decoration: line-through' : ''">
            {{ getCptRecommendedCode(cpt) }}
          </td>
          <td :class="{ 'red-font': isRecommendedRedFont(cpt, worksheet.cpts) }">
            {{ getCptRecommendedDescription(cpt, worksheet.cpts) }}
          </td>
          <td :class="{ 'red-font': isRecommendedRedFont(cpt, worksheet.cpts) }">{{ cpt.reasonForChangeDescription }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  export default {
    name: 'ProWorksheetCptTablePivoted',
    props: {
      worksheet: {
        type: Object
      },
      isCoder: {
        type: Boolean
      },
      codeTypesParam: {
        type: Array,
        default: function() {
          return []
        }
      },
      optionalParameters: {
        type: Object,
        default: function() {
          return {}
        }
      }
    },
    components: {},
    data() {
      return {}
    },
    methods: {
      showPreCptCodeType() {
        if (this.worksheet.cpts.length > 0 && this.codeTypesParam.length > 0) {
          return this.codeTypesParam.includes(this.worksheet.cpts[0].preCptCodeType)
        }
        return true
      },
      showOriginalCptCodeType() {
        if (this.worksheet.cpts.length > 0 && this.codeTypesParam.length > 0) {
          return this.codeTypesParam.includes(this.worksheet.cpts[0].codeType)
        }
        return true
      },
      isCptRowChange(cpt) {
        if (cpt.recommendedCpt || cpt.originalDeleted) {
          return true
        }

        if (((this.codeTypesParam.length > 0 && this.codeTypesParam.includes(cpt.preCptCodeType)) || this.codeTypesParam.length === 0) && (cpt.preCptDeleted || cpt.originalCPT)) {
          return true
        }

        return false
      },
      getCptRecommendedDescription(cpt, cpts) {
        if (cpt.originalDeleted) {
          if (cpt.recDesc) {
            return `Delete CPT - ${cpt.recDesc}`
          }
          return 'Delete CPT'
        }

        if (cpt.recDesc && cpt.lineSequence === 1 && cpts.some(x => x.newPrimary)) {
          if (cpt.recDesc) {
            return `Resequence Principal CPT - ${cpt.recDesc}`
          }
          return 'Resequence Principal CPT'
        }

        return cpt.recDesc
      },
      getCptDeletedDescription(cpt) {
        if (cpt.origDesc) {
          return `Delete CPT - ${cpt.origDesc}`
        }
        return 'Delete CPT'
      },
      isPreCptRedFont(cpt, cpts) {
        if (cpt.preCptDeleted || (cpt.originalDeleted && cpt.recommendedCpt !== cpt.preCpt)) {
          return true
        }
        return false
      },
      isOriginalRedFont(cpt) {
        if (cpt.originalDeleted || cpt.preCptDeleted) {
          return true
        }
        return false
      },
      isRecommendedRedFont(cpt) {
        return cpt.originalDeleted || cpt.preCptDeleted
      },
      getCptRecommendedCode(cpt) {
        if (cpt.originalDeleted) {
          const originalCalc = `${cpt.originalCPT || ''}${cpt.originalModifierCalc || ''}` || `${cpt.preCpt || ''}${cpt.preModifierCalc || ''}`
          return originalCalc
        }
        if (cpt.recommendedCpt) {
          const recommendedCalc = `${cpt.recommendedCpt || ''}${cpt.recommendedModifierCalc || ''}`
          return recommendedCalc
        }
        return null
      },
      getVisibleColumnCount() {
        let count = 0
        if (this.showPreCptCodeType()) {
          count += 2 // pre-cpt, pre-description
        }
        if (this.showOriginalCptCodeType()) {
          count += 2 // orig-cpt, orig-description
        }
        count += 3 // rec-cpt, rec-description, reason-for-change
        return count
      }
    }
  }
</script>

<style scoped>
  .red-font {
    color: red;
  }

  .bold {
    font-weight: bold;
  }

  .codeTypeHeader {
    text-align: left;
    padding: 4px 0px 4px 5px;
    border-left: 8px solid #3378aa7c;
    font-style: italic;
  }
</style>
